<template>
    <div v-show="media.length > 1 && show" class="slideshow" dusk="slideshow-component">
        <button class="slideshow-prev" @click="onPrev" :disabled="prevDisabled">
            <i class="fa fa-chevron-left"></i> <span>Previous</span>
        </button>
        <button class="slideshow-next" @click="onNext" :disabled="nextDisabled">
            <i class="fa fa-chevron-right"></i> <span>Next</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'SlideShow',
    props: {
        media: {
            type: Array,
            required: true,
        },
        currentItem: {
            type: [Object, Boolean],
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        currentIndex() {
            return this.media.findIndex(item => item.id === this.currentItem.id);
        },
        nextDisabled() {
            return !this.loop && this.isLast;
        },
        prevDisabled() {
            return !this.loop && this.isFirst;
        },
        isFirst() {
            return this.currentIndex === 0;
        },
        isLast() {
            return this.currentIndex === (this.media.length - 1);
        },
    },
    methods: {
        onNext() {
            let next = this.currentIndex + 1;
            if (this.loop && this.isLast) next = 0;
            this.$emit('slideshow-nav', next);
        },
        onPrev() {
            let prev = this.currentIndex - 1;
            if (this.loop && this.isFirst) prev = this.media.length - 1;
            this.$emit('slideshow-nav', prev);
        },
    },
}
</script>

<style lang="scss" scoped>
.slideshow {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;

    padding: 0 1rem;
    line-height: 1;

    pointer-events: none;

    &-next, &-prev {
        font-family: inherit;
        font-size: 100%;
        margin: 0;
        padding: 0;
        appearance: none;
        border: 0;
        border-radius: 10rem;
        width: 5rem;
        height: 5rem;

        background: rgba(white, 0.4);

        pointer-events: all;

        i {
            font-size: 150%;
            color: rgba(black, 0.8);
        }

        span {
            display: none;
        }

        &:active, &:hover {
            background: rgba(white, 1);

            i {
                color: rgba(black, 1);
            }
        }

        &[disabled="disabled"] {
            background: rgba(white, 0.2);
            cursor: not-allowed;

            i {
                color: rgba(black, 0.4);
            }
        }
    }
}
</style>
